import { supabase } from './supabase'
import { STORAGE_LIMITS } from './constants'

export const ATTACHMENTS_BUCKET = 'attachments'
export const AVATARS_BUCKET = 'avatars'

function sanitizeName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .slice(0, 120)
}

export function validateAttachment(file: File): string | null {
  if (file.size > STORAGE_LIMITS.attachmentBytes) return 'Arquivo acima de 50 MB.'
  if (!STORAGE_LIMITS.attachmentMime.includes(file.type))
    return `Tipo não permitido: ${file.type || 'desconhecido'}.`
  return null
}

export function validateAvatar(file: File): string | null {
  if (file.size > STORAGE_LIMITS.avatarBytes) return 'Imagem acima de 2 MB.'
  if (!STORAGE_LIMITS.avatarMime.includes(file.type)) return 'Use PNG, JPEG ou WebP.'
  return null
}

/** Caminho: {workspaceId}/{escopo}/{uuid}-{arquivo}. O 1º segmento autoriza (RLS). */
export function buildAttachmentPath(workspaceId: string, scope: string, fileName: string): string {
  return `${workspaceId}/${scope}/${crypto.randomUUID()}-${sanitizeName(fileName)}`
}

/** URL ASSINADA e temporária. Nunca expomos anexos por URL pública permanente. */
export async function getSignedUrl(storagePath: string, expiresIn = 3600): Promise<string> {
  const { data, error } = await supabase.storage
    .from(ATTACHMENTS_BUCKET)
    .createSignedUrl(storagePath, expiresIn)
  if (error) throw error
  return data.signedUrl
}

export async function removeAttachmentObject(storagePath: string): Promise<void> {
  await supabase.storage.from(ATTACHMENTS_BUCKET).remove([storagePath])
}

export async function uploadAvatar(userId: string, file: File): Promise<string> {
  const path = `${userId}/avatar-${crypto.randomUUID()}.${file.name.split('.').pop() ?? 'png'}`
  const { error } = await supabase.storage.from(AVATARS_BUCKET).upload(path, file, { upsert: true })
  if (error) throw error
  const { data } = supabase.storage.from(AVATARS_BUCKET).getPublicUrl(path)
  return data.publicUrl
}
